import type { Playlists, Sites, Videos } from '@resi-sites/types';
import type { MockItem } from '@preview/types';

const getDataTypeGuard = (
  data: MockItem['data']
): {
  hasFeeds: boolean;
  hasPlaylists: boolean;
  hasVideos: boolean;
  playlistData: Playlists.Get.Playlist | null;
  siteData: Sites.Get.Site | null;
  videoData: Videos.Get.Video | null;
} => {
  const isSiteData = (data: unknown): data is Sites.Get.Site =>
    Boolean(data && typeof data === 'object' && 'feeds' in data);

  const isPlaylistData = (data: unknown): data is Playlists.Get.Playlist =>
    Boolean(data && typeof data === 'object' && 'videos' in data);

  const isVideoData = (data: unknown): data is Videos.Get.Video =>
    Boolean(data && typeof data === 'object' && 'playlists' in data);

  const hasFeeds = isSiteData(data);
  const hasPlaylists = isPlaylistData(data);
  const hasVideos = isVideoData(data);

  return {
    hasFeeds,
    hasPlaylists,
    hasVideos,
    siteData: hasFeeds ? data : null,
    playlistData: hasPlaylists ? data : null,
    videoData: hasVideos ? data : null,
  };
};

export default getDataTypeGuard;
